import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';

import './TareasSubtabla.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import FormTarea from '../FormTarea/FormTarea.js';

import tareaContext from '../../context/tareaContext/tareaContex.js';
import { estructuraTarea } from '../../utils/estructuras.js';
import { useScrollToBottom } from '../../customHooks/useScrollToBottom.js';

const TareasSubtabla = ({tareas,  setState,  tablaSeleccionada, tipo, completedTasks=0, componentePadre, handleChangeCheckTask=()=>console.log("Check"), tDocID='', optionsProcedimientos = [], procedimientoList = [], optionsActivosProduccion = null, templatesList = []}) =>{

    const [data,setData] = useState(''); //Data contiene la informacion de la tarea modificada.
    const [showAddTarea,setShowAddTarea] = useState(false); //Estado encargado de renderizar o no el FormTarea, independientemente de si se modifica o agrega una nueva.
    const [nuevoEditado, setNuevoEditado] = useState("Agregar"); //Setea el titulo mostrado luego en FormTarea, donde se indica si se esta agregando una tarea o modificandola.
    const [indexToUpdate,setIndexToUpdate] = useState(-1); //Index donde al clickear boton Editar Tarea se especifica el indice de la tarea a modificar en el procedimiento.
    const [options,setOptions] = useState([]);
    const containerRef = useScrollToBottom(tareas.length);
    
    const tContext = useContext(tareaContext);
    const {actualizarTareaLista,tareaIDLista} = tContext;

    const minimizar = () => {
        setShowAddTarea(false);
    }

    const createOptions = () => {
        const copyTareas = JSON.stringify(tareaIDLista)
        const tareas = JSON.parse(copyTareas)
        let optionsT = [];
        if(tareas.length > 0){
            optionsT = tareas.map((t) => {return {
                label:t.name, value: t.codTarea, id: t['_id'], descrp: t.descrp, name:t.name, showDescrp: t.showDescrp
            }})
        }
        setOptions({opcionesTareas:optionsT});
    }

    const handleChangeTareas = (tarea = {},i,taskDescrp = undefined) => {
        setState((prevState) => {
            let preTareas = prevState.tareas.slice();
            const copyTareas = JSON.stringify(preTareas)
            const tareas = JSON.parse(copyTareas)
            
            if(taskDescrp != undefined && Object.keys(tarea).length == 0){ 
                if(tareas[i].value !== ''){ 
                    tareas[i].taskDescrp = taskDescrp;
                }
                let newState = {...prevState,['tareas']:tareas};
                return newState; 
            }else{
                if(Object.keys(tarea).length == 0){
                    tareas.splice(i,1);
                }
                else if(tareas[i].value !== ''){ 
                    tareas[i] = tarea;
                    tareas[i].taskDescrp = "";
                }else{
                    tareas[i] = tarea;
                    tareas[i].taskDescrp = "";
                    tareas.push({...estructuraTarea});
                }
                let newState = {...prevState,['tareas']:tareas};
                return newState; 
            }   
        })
    }

    const handleDeleteTarea = (tarea,index) => {
        setState((prevState) => {
            let tareas = prevState.tareas.slice();
            if(tareas.length > 0 && index > -1 && tarea.label !== ''){
                tareas = prevState.tareas.filter((tarea,i) => i !== index);
            }
            let newState = {...prevState,['tareas']:tareas};
            return newState;
        });
    }

    const handleProcToGetTasksFor = (e) =>{
        let procFound = procedimientoList.find(p => p._id == e.id);
        let tareasEncontradas = procFound.tareas.slice();
        tareasEncontradas = tareasEncontradas.filter(tn => !tareas.some(ta => ta.id == tn.id));
        if(tareasEncontradas.length > 0){
            let i = tareas.length - 1;
            for(const tarea of tareasEncontradas){
                let newTarea = {descrp: tarea.descrp, id: tarea.id, label: tarea.descrp, name: tarea.name, taskDescrp: '', value: tarea.codTarea};
                handleChangeTareas(newTarea,i);
                i++;
            }
        }
    }

    const optionsTemplates = templatesList.map(t => ({ value: t.codTemplate, label: `${t.codTemplate} - ${t.name}`, id: t._id }));

    const handleTemplateToGetTasksFor = (e) => {
        let templateFound = templatesList.find(t => t._id == e.id);
        if (!templateFound || !templateFound.tareas) return;
        let tareasEncontradas = templateFound.tareas.slice();
        tareasEncontradas = tareasEncontradas.filter(tn => !tareas.some(ta => ta.id == tn.id));
        if (tareasEncontradas.length > 0) {
            let i = tareas.length - 1;
            for (const tarea of tareasEncontradas) {
                let newTarea = {
                    descrp: tarea.descrp, id: tarea.id, label: tarea.descrp || tarea.name, name: tarea.name, taskDescrp: '', value: tarea.codTarea || tarea.value,
                    activo: tarea.codActivo ? { id: tarea.activoIDRef || '', value: tarea.codActivo, label: tarea.activoNombre || tarea.codActivo } : (tarea.activo || null),
                    unidadMedida: tarea.unidadMedida || '',
                    horasCarga: tarea.horasCarga || ''
                };
                handleChangeTareas(newTarea, i);
                i++;
            }
        }
    };

    const handleChangeActivoTarea = (selectedOption, i) => {
        setState((prevState) => {
            let tareas = prevState.tareas.slice();
            tareas[i] = {
                ...tareas[i],
                activo: selectedOption ? {
                    id: selectedOption.activoID,
                    value: selectedOption.activoCod,
                    label: selectedOption.label
                } : { id: '', value: '', label: '' }
            };
            return { ...prevState, tareas };
        });
    };

    const handleChangeCargaTiempoTarea = (value, i) => {
        setState((prevState) => {
            let tareas = prevState.tareas.slice();
            tareas[i] = { ...tareas[i], cargaTiempo: value };
            return { ...prevState, tareas };
        });
    };

    const handleChangeTareaField = (i, field, value) => {
        setState((prevState) => {
            let tareas = prevState.tareas.slice();
            tareas[i] = { ...tareas[i], [field]: value };
            return { ...prevState, tareas };
        });
    };

    useEffect(()=>{
        createOptions();
    },[tareaIDLista])

    const cantidadTareas = (tareas != undefined) ? tareas.filter(t => t.label != '').length : 0;

    return <div className={`${(tablaSeleccionada != 'tareas' && tablaSeleccionada != 'checks') && 'inactive'} tareasDiv`} id={`${(tipo =='tareaOT' && completedTasks == cantidadTareas && cantidadTareas > 0) ? 'tareasCompletadas' : ''}`}>
    {tipo == 'tareaMant' && <label className='taskForProcLabelTable'>Tareas por Procedimiento
        <div className='getTareasByProcDiv'>
            <label>Recuperar desde otro Procedimiento: </label>
            <SelectControl placeholder={"Seleccione una procedimiento..."} modo={"Nuevo"} setShowAdd={setShowAddTarea} idSelect={"getTareasByProc"} handleChengeSelect={handleProcToGetTasksFor} optionsSelect={optionsProcedimientos} valueSeleccionada={{}} tipo={'getTareasByProc'}  selectSelect={handleProcToGetTasksFor} setData={setData} index={1} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate}/>
        </div>
    </label>}
    {tipo == 'tareaTemplate' && <label className='taskForProcLabelTable'>Tareas por Template
        <div className='getTareasByProcDiv'>
            <label>Recuperar desde otro Template: </label>
            <SelectControl placeholder={"Seleccione un template..."} modo={"Nuevo"} setShowAdd={setShowAddTarea} idSelect={"getTareasByTemplate"} handleChengeSelect={handleTemplateToGetTasksFor} optionsSelect={optionsTemplates} valueSeleccionada={{}} tipo={'getTareasByTemplate'} selectSelect={handleTemplateToGetTasksFor} setData={setData} index={1} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate}/>
        </div>
    </label>}
    {tipo == 'tareaOT' && <label>Tareas Completadas {completedTasks} / {cantidadTareas}</label>}
    <div className="tareasXprocedimiento" ref={containerRef}>
        {(tareas == undefined) ? <h5>Cargando tareas...</h5> : 
        tareas.length > 0 && tareas.map((tarea,i) =><div className="tareaWrapper" key={`${tarea.codTarea}-${i}`}>
            <div className="tareaDiv">
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteTarea(tarea,i)} />

                <SelectControl placeholder={"Seleccione una tarea..."} modo={"Nuevo"} setShowAdd={setShowAddTarea} idSelect={"tarea"} handleChengeSelect={handleChangeTareas} optionsSelect={options.opcionesTareas} valueSeleccionada={tarea} tipo={tipo}  selectSelect={handleChangeTareas} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                {tipo == 'tareaOT' && <label className='customCheckbox'>
                    <input disabled={tarea.label == ''} value={tarea.done} className='checkboxTask' type='checkbox' onChange={(e) => handleChangeCheckTask(e,i)}/>
                    <span className={`${(tarea.done) ? 'checked' : ''}`}></span>
                </label>}

                {tipo == 'tareaOT' && componentePadre !== 'FormReq' && tarea.label !== '' && <div className="tareaPorcentajeContainer">
                    <input
                        type="number"
                        className="tareaPorcentajeInput"
                        value={tarea.porcentajeCumplimiento || ''}
                        onChange={(e) => {
                            let val = parseFloat(e.target.value) || 0;
                            if (val < 0) val = 0;
                            if (val > 100) val = 100;
                            setState((prevState) => {
                                let tareas = prevState.tareas.slice();
                                tareas[i] = { ...tareas[i], porcentajeCumplimiento: val.toString(), done: val >= 100 };
                                return { ...prevState, tareas };
                            });
                        }}
                        min="0"
                        max="100"
                        placeholder="0"
                    />
                    <div className="tareaPorcentajeBarraContainer">
                        <div
                            className="tareaPorcentajeBarra"
                            style={{
                                width: `${parseFloat(tarea.porcentajeCumplimiento) || 0}%`,
                                backgroundColor: parseFloat(tarea.porcentajeCumplimiento) >= 100 ? '#4caf50' : '#3d4d87'
                            }}
                        />
                        <span className="tareaPorcentajeLabel">%</span>
                    </div>
                </div>}

                <input className="inputDescrp" name="taskDescrp" value={tarea.taskDescrp} onChange={(e) => handleChangeTareas({},i,e.target.value)} placeholder="Ingrese una descripción adicional..."/>
            </div>
            {optionsActivosProduccion && tarea.label !== '' && <div className="tareaActivoRow">
                <label className="tareaActivoLabel">Activo:</label>
                <Select
                    className="selectActivoTarea"
                    placeholder="Seleccione un activo..."
                    options={optionsActivosProduccion}
                    value={tarea.activo?.label ? tarea.activo : null}
                    onChange={(opt) => handleChangeActivoTarea(opt, i)}
                    isClearable
                />
                {tipo !== 'tareaTemplate' && <div className="cargaTiempoTareaContainer">
                    <label className="tareaActivoLabel">Carga de Tiempo en Horas:</label>
                    <input
                        type="number"
                        className="cargaTiempoTareaInput"
                        value={tarea.cargaTiempo || ''}
                        onChange={(e) => handleChangeCargaTiempoTarea(e.target.value, i)}
                        step="0.0001"
                        min="0"
                        placeholder="0"
                    />
                    <span className="minutosLeyendaTarea">
                        ({Math.round((parseFloat(tarea.cargaTiempo) || 0) * 60)} minutos)
                    </span>
                </div>}
                {tipo === 'tareaTemplate' && tarea.activo?.label && <>
                    <span className="tareaLeyendaSeparator">|</span>
                    <span>Por cada un</span>
                    <select className="tareaLeyendaSelect"
                        value={tarea.unidadMedida || ''}
                        onChange={(e) => handleChangeTareaField(i, 'unidadMedida', e.target.value)}
                    >
                        <option value="">Seleccionar...</option>
                        <option value="MT">Metro</option>
                        <option value="KG">KG</option>
                        <option value="UNI">Unidad</option>
                    </select>
                    <span>la carga de tiempo sobre el Activo es de</span>
                    <input className="tareaLeyendaInput"
                        type="number"
                        value={tarea.horasCarga || ''}
                        onChange={(e) => handleChangeTareaField(i, 'horasCarga', e.target.value)}
                        min="0"
                        step="0.5"
                    />
                    <span>Horas.</span>
                </>}
            </div>}
        </div>)
        }
        {showAddTarea && <FormTarea data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeTareas={handleChangeTareas} index={indexToUpdate} tDocID={tDocID}/> }
    </div>
    </div>
}

//Esto se ejecuta antes de cada re-render de TareasSubtabla.
//prev son las props de la version actualmente renderizada.
//next son las props que el padre esta intentando pasarle a nuestro componente
//dependiendo si hay diferencias o no, se renderiza de nuevo o no.
export default React.memo(TareasSubtabla, (prev, next) => {
    return prev.tareas === next.tareas
    && prev.completedTasks === next.completedTasks 
    && prev.tablaSeleccionada === next.tablaSeleccionada
    && prev.tDocID === next.tDocID
});